<template>
  <div class="p-the-page-j04">
    <div class="p-the-page-j04__inner">
      <div class="p-the-page-j04__image">
        <IconNoSearchResult :icon-size="iconSize" />
      </div>
      <div class="p-the-page-j04__body">
        <div class="p-the-page-j04__body__text">
          <p>
            「{{ searchKeyword }}」に一致する結果は
            <br class="u-display-none--pc" />ありませんでした
          </p>
          <p class="p-the-page-j04__body__text--primary">
            別のキーワードで検索してください
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconNoSearchResult from "@/common/components/icons/IconNoSearchResult.vue";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    keyword: { type: String, default: "" }
  },
  components: {
    IconNoSearchResult
  }
})
export default class ThanksPointListSearchNotFound extends Vue {
  keyword!: string;

  searchKeyword = "";
  currentPagedoSearch!: number;

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : undefined;
    this.searchKeyword = this.keyword || search || "";
  }
  get locationSearch() {
    const search = document.location as unknown;
    const encodeSearchKeyword = decodeURIComponent(search as string);
    const keyword = encodeSearchKeyword.replace(/\+/g, " ");
    return keyword.split("=")[1];
  }

  get iconSize() {
    const isSp = globals.isSpScreenWidth;

    if (isSp) {
      return 103;
    } else {
      return 158;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-j04 {
  @include pc {
    padding-top: rem(40);
  }
  @include sp {
    padding-top: rem(32);
  }

  &__image {
    text-align: center;
  }

  &__body {
    @include pc {
      margin-top: rem(32);
    }
    @include sp {
      margin-top: rem(24);
    }
    &__text {
      font-size: $text-size__body--l;
      text-align: center;
      font-weight: bold;

      p + p {
        @include pc {
          margin-top: rem(8);
        }
        @include sp {
          margin-top: rem(16);
        }
      }

      &--primary {
        @include pc {
          font-size: $text-size__body--m;
        }
        @include sp {
          font-size: $text-size__body--s;
        }
        color: $common-primary;
        display: block;
      }
    }
  }
}
</style>
